import { Inputfiledsbase } from './models/inputfiledsbase';

export class TextboxQuestion extends Inputfiledsbase<string> {
  override controlType = 'textbox';
}